import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    countries: null,
    loading: false,
    error: null
};

const getCountriesRequest = (state, action) => {
    return updateState(state, {
        loading: true
    });
};

const getCountriesSuccess = (state, action) => {
    const filteredCountries = ['United States Minor Outlying Islands', 'Virgin Islands (British)', 'Virgin Islands (U.S.)'];
    let countries = action.countries
        .filter(country => !filteredCountries.includes(country.name))
        .map(country => country.name);

    let indexOfUsa = countries.indexOf('United States of America');
    countries.splice(indexOfUsa, 1);
    countries.unshift('United States of America');

    return updateState(state, {
        loading: false,
        countries: countries
    });
};

const getCountriesError = (state, action) => {
    return updateState(state, {
        error: action.error
    });
};

export const countriesReducer = (state=initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_COUNTRIES_REQUEST : return getCountriesRequest();
        case actionTypes.GET_COUNTRIES_SUCCESS : return getCountriesSuccess(state, action);
        case actionTypes.GET_COUNTRIES_ERROR : return getCountriesError(state, action);
        default : return state;
    }
};
